.root {
	display: flex;
	flex-direction: column;
	gap: var(--space-3);
	height: 100%;
}

.header {
	display: flex;
	align-items: center;
	gap: var(--space-2);
	color: var(--ink-muted);
}

.emoji {
	font-size: 1.1rem;
	line-height: 1;
}

.heading {
	font-weight: 600;
	font-size: 0.9rem;
}

.rows {
	display: flex;
	flex-direction: column;
	gap: var(--space-2);
	min-width: 0;
}

.row {
	display: flex;
	flex-direction: column;
	gap: 2px;
	min-width: 0;
}

.rowLabel {
	font-size: 0.7rem;
	font-weight: 600;
	letter-spacing: 0.05em;
	text-transform: uppercase;
	color: var(--ink-muted);
}

.rowTitle {
	font-weight: 600;
	font-size: 1rem;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.rowMuted .rowTitle {
	color: var(--ink-muted);
	font-weight: 500;
}

.recipeLink {
	display: inline-flex;
	align-items: center;
	gap: var(--space-1);
	color: inherit;
	text-decoration: none;
	min-width: 0;
}

.recipeLink:hover .rowTitle {
	text-decoration: underline;
}

.placeholder {
	color: var(--ink-muted);
	font-style: italic;
}
